/**
 * @hidden
 * @module geo/bus
 * @private
 */
import { Store } from 'redux';
import { GEO_API_PROXY_READY } from '../payload/proxy/GEO_API_PROXY_READY';
import { AppStore } from '../store/app';
// import busService from '.';
import { ResponseBus } from './bus.service';

/**
 * Class for comunication with proxy.
 * Several app could be registered with unique identifier.
 * @private
 */
export class BusServiceIframeSync {
  private registeredApp: IHashAppSync = {};

  /**
   * Initialize Bus service with config
   * @param config object of configuration. Available options are post-robot
   * config option (https://github.com/krakenjs/post-robot)
   */
  public init(config: any) {
    // bus.init();
    // Object.assign(bus.CONFIG, config);
  }

  /**
   * Register new app to bus service
   * @param uidApp
   * @param configApp
   */
  public registerNewApp(uidApp: string, configApp: any) {
    // const promise = busService.geoBus.getReady(busService.geoBus,
    // uidApp).then((event: GEO_API_PROXY_READY) => {
    //   this.registeredApp[uidApp].inited = true;
    //   this.registeredApp[uidApp].isReady = event;
    //   return event;
    // });

    const domain =
      (configApp.geo && configApp.geo.domain) ? configApp.geo.domain : '*';
    this.registeredApp[uidApp] = new BusAppSync(uidApp, domain);
  }

  /**
   * get BusApp for registered App
   * @param {string} uid
   * @returns {BusApp}
   */
  public getRegisteredApp(uid: string) {
    if (!this.registeredApp[uid]) {
      throw Error('No app register in Bus Service for uid ' + uid);
    }
    return this.registeredApp[uid];
  }

  /**
   * Save the iframe in wich proxy bus is set
   * @param c iframe DOM element
   */
  public setClientReceiver(c: string | HTMLIFrameElement, uidApp: string) {
    const registeredApp = this.registeredApp[uidApp];

    if (typeof c === 'string') {
      const el = document.getElementById(c) as HTMLIFrameElement;
      if (el !== null) {
        registeredApp.receiver = el;
      }
    } else {
      registeredApp.receiver = c;
    }

    // if (registeredApp.receiver == null) {
    //   throw new Error('registred App has no receiver set');
    // }

    // registeredApp.listener = bus.listener({
    //   domain: registeredApp.domain,
    //   window: registeredApp.receiver.contentWindow
    // });
    // registeredApp.sender = bus.client({
    //   domain: registeredApp.domain,
    //   window: registeredApp.receiver.contentWindow
    // });
  }

  /**
   * @internal
   * @param {Store<AppStore>} storeApp
   * @param {string} uidApp
   */
  public bindToStore(storeApp: Store<AppStore>, uidApp: string) { }

  /**
   * Is bus ready for communicate with proxy of app
   * @param uidApp unique identifier for app
   */
  public getReady(bus: BusServiceIframeSync, uidApp: string):
    Promise<GEO_API_PROXY_READY> {
    return bus.registeredApp[uidApp].promiseInit;
  }

  /**
   * Send a action message to proxy and return a promise.
   * @param type Message type
   * @param message payload
   */
  public send<ResponseType>(type: string, message: any, uidApp: string):
    ResponseType {
    return this.getRegisteredApp(uidApp).send(type, message);
  }

  /**
   * @param type
   * @param message
   * @param uidApp unique identifier for app
   */
  public sendP<ResponseType>(type: string, message: any, uidApp: string):
    ResponseBus<ResponseType> {
    return this.getRegisteredApp(uidApp).sendP(type, message);
  }
}

export const geoBusDirect = new BusServiceIframeSync();


/**
 * @internal
 */
export class BusAppSync {
  public uid: string;
  public listener: any;
  public sender: any;
  private _receiver: HTMLIFrameElement | null = null;
  public promiseInit: Promise<GEO_API_PROXY_READY>;
  public domain: string = '*';
  public isReady: GEO_API_PROXY_READY = { 'ready': false };
  public inited: boolean = false;
  public sameDomain = false;
  public loaded = false;
  /**
   * @param {string} uid
   * @param {Promise<GEO_API_PROXY_READY>} promise
   * @param {string} domain
   */
  constructor(uid: string, domain: string) {
    this.uid = uid;
    this.domain = domain;
    this.inited = true;

    this.promiseInit = new Promise(this.isLoaded.bind(this));
  }

  private isLoaded(resolve:()=>any,reject:()=>any) {
    if (this._receiver !== null && this._receiver.contentWindow) {
      try {
        this._receiver.contentWindow.document.onloadstart = () => {
          resolve();
        }
      } catch (e) {
        console.error('error in BusAppSync.isLoaded',e)
        reject();
      }
    }
  }

  public set receiver(el: HTMLIFrameElement | null) {
    if (el !== null) {
      const win: any = el.contentWindow;
      if (!win) {
        throw Error('Iframe not loaded');
      }

      try {
        this._receiver = el;
        el.onloadend = () => {
          this.loaded = true;
          const doc: any = el.contentDocument;
          if (doc && doc.domain && doc.domain === window.document.domain) {
            this.sameDomain = true;
          } else {
            console.warn(
              'Iframe and parent window are not on same domain. No sync access available. + ')
          }
        }
      } catch (e) {
        console.warn(
          'Iframe and parent window are not on same domain. No sync access available. - ')
      }
    }
  }

  public get receiver(): HTMLIFrameElement | null {
    return this._receiver;
  }

  public send<ResponseType>(type: string, message: any): ResponseType {
    if (this._receiver === null) {
      throw Error('no receiver');
    }
    if (!this.loaded && this._receiver && !this.sameDomain) {
      const doc: any = this._receiver.contentDocument;
      if (doc && doc.domain && doc.domain === window.document.domain) {
        this.sameDomain = true;
      }
    }
    if (!this.sameDomain) {
      console.warn(
        'Trying to do sync communication with iframe but not available. (not same domain).')
      return { done: false } as any;
    }

    const win: any = this._receiver.contentWindow;
    const service = win.geoApi2Service;
    return service.receiveSyncAction(type, message);
  }

  public sendP<ResponseType>(type: string, message: any):
    ResponseBus<ResponseType> {
    if (this._receiver === null) {
      throw Error('no receiver');
    }
    if (!this.loaded && this._receiver && !this.sameDomain) {
      const doc: any = this._receiver.contentDocument;
      if (doc && doc.domain && doc.domain === window.document.domain) {
        this.sameDomain = true;
      }
    }
    if (!this.sameDomain) {
      console.warn(
        'Trying to do sync communication with iframe but not available. (not same domain).')
      return { done: false } as any;
    }

    const win: any = this._receiver.contentWindow;
    const service = win.geoApi2Service;
    return service.receiveSyncAction(type, message);
  }
}

/**
 * @private
 */
interface IHashAppSync {
  [uid: string]: BusAppSync;
}
